var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "url(#paint0_linear_1677_24748)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1677_24748)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.74065 5.96289H13.9999C14.5703 5.96289 15.0369 6.42956 15.0369 6.99993V14.2592C15.0369 14.8296 14.5703 15.2962 13.9999 15.2962H6.74065C6.17028 15.2962 5.70361 14.8296 5.70361 14.2592V6.99993C5.70361 6.42956 6.17028 5.96289 6.74065 5.96289ZM8.61404 7.82617C8.03552 7.82617 7.56653 8.29516 7.56653 8.87368C7.56653 9.45221 8.03552 9.9212 8.61404 9.9212H12.1057C12.6843 9.9212 13.1533 9.45221 13.1533 8.87368C13.1533 8.29516 12.6843 7.82617 12.1057 7.82617H8.61404ZM7.56653 11.5505C7.56653 11.2934 7.77497 11.085 8.03209 11.085H12.6877C12.9448 11.085 13.1533 11.2934 13.1533 11.5505C13.1533 11.8076 12.9448 12.0161 12.6877 12.0161H8.03209C7.77497 12.0161 7.56653 11.8076 7.56653 11.5505ZM8.03209 12.4823C7.77497 12.4823 7.56653 12.6907 7.56653 12.9478C7.56653 13.2049 7.77497 13.4134 8.03209 13.4134H12.6877C12.9448 13.4134 13.1533 13.2049 13.1533 12.9478C13.1533 12.6907 12.9448 12.4823 12.6877 12.4823H8.03209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.74065 5.96289H13.9999C14.5703 5.96289 15.0369 6.42956 15.0369 6.99993V14.2592C15.0369 14.8296 14.5703 15.2962 13.9999 15.2962H6.74065C6.17028 15.2962 5.70361 14.8296 5.70361 14.2592V6.99993C5.70361 6.42956 6.17028 5.96289 6.74065 5.96289ZM8.61404 7.82617C8.03552 7.82617 7.56653 8.29516 7.56653 8.87368C7.56653 9.45221 8.03552 9.9212 8.61404 9.9212H12.1057C12.6843 9.9212 13.1533 9.45221 13.1533 8.87368C13.1533 8.29516 12.6843 7.82617 12.1057 7.82617H8.61404ZM7.56653 11.5505C7.56653 11.2934 7.77497 11.085 8.03209 11.085H12.6877C12.9448 11.085 13.1533 11.2934 13.1533 11.5505C13.1533 11.8076 12.9448 12.0161 12.6877 12.0161H8.03209C7.77497 12.0161 7.56653 11.8076 7.56653 11.5505ZM8.03209 12.4823C7.77497 12.4823 7.56653 12.6907 7.56653 12.9478C7.56653 13.2049 7.77497 13.4134 8.03209 13.4134H12.6877C12.9448 13.4134 13.1533 13.2049 13.1533 12.9478C13.1533 12.6907 12.9448 12.4823 12.6877 12.4823H8.03209Z",
    fill: "url(#paint1_linear_1677_24748)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1677_24748",
    x1: 3.24074,
    y1: 21,
    x2: 19.7037,
    y2: 3.62963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DB6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACC3FF",
    stopOpacity: 0.46
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1677_24748",
    x1: 6.33993,
    y1: 13.5999,
    x2: 14.2477,
    y2: 7.24736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F8FE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89A7F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1677_24748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.33333,
    height: 9.33333,
    fill: "white",
    transform: "translate(5.71509 5.97461)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostIcon);
export default __webpack_public_path__ + "static/media/PostIcon.8d345a56c8c387bd528aedea8fdd35a5.svg";
export { ForwardRef as ReactComponent };